var React = require('react');

function PlayCircle (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"14.5","cy":"15","r":"14.5","fill":"black","fillOpacity":"0.15","key":0}),React.createElement("path",{"d":"M18.9022 15.4998L12.299 19.3122L12.299 11.6874L18.9022 15.4998Z","key":1})]);
}

PlayCircle.defaultProps = {"viewBox":"0 0 29 30"};

module.exports = PlayCircle;

PlayCircle.default = PlayCircle;
